import { useFetchNearbyStores } from "@sushicorp/services";
import { useFetchCoordsFromGoogleAddress } from "@sushicorp/services";
import { dropdownConfigs } from "@sushicorp/utils";
import { debounce } from "@sushicorp/utils";
import { events } from "artisn/analytics";
import { Store } from "artisn/types";
import { SearchBar } from "artisn-ui-react";
import React, { useState, useEffect } from "react";

import { SearchStoreContentStyled } from "./SearchStore.styles";
import Styles from "./SearchStore.styles";
import { SearchStoreProps as Props } from "./SearchStore.types";
import InfoCard from "../InfoCard/InfoCard";
import useAnalytics from "contexts/analytics/analytics.context.hooks";
import useI18n from "hooks/useI18n";
import { Google } from "types/geo.types";
import { notify } from "utils/common.utils";
import { dismissErrorNotification } from "utils/notifications.utils";
import { createErrorNotification } from "utils/notifications.utils";

const { logFindLocation } = events.geo;

const SearchStore: React.FC<Props> = props => {
  const { onChange } = props;
  const t = useI18n();
  const { analyticsInitialized } = useAnalytics();
  const [query, setQuery] = useState<string | undefined>();
  const [searchResults, setSearchResults] = useState<
    Google.Coordinates | undefined
  >();
  const [showDropdown, setShowDropdown] = useState(false);

  const { data: nearbyStores } = useFetchNearbyStores(searchResults, notify);
  // TODO: Maps api key
  const { data, error } = useFetchCoordsFromGoogleAddress("", query);

  const submitHandler = (query: string) => {
    setQuery(query);
  };

  const changeHandler = (item: Store) => {
    setShowDropdown(false);
    onChange(item);
  };

  const onInputClick = () => {
    setShowDropdown(true);
  };

  const clearHandler = () => {
    setQuery(undefined);
    setShowDropdown(false);
  };

  const queryChangeHandler = debounce((value: string) => {
    if (value.length < 3) return;
    setQuery(value);
  }, 500);

  useEffect(() => {
    if (!data || !analyticsInitialized) return;
    const { location } = data.geometry;
    setSearchResults(location);
    logFindLocation();
  }, [data, analyticsInitialized]);

  useEffect(() => {
    if (!error) return;
    dismissErrorNotification();
    createErrorNotification(t.errors.failSearch);
    console.error(error);
  }, [error, t]);

  return (
    <Styles className="SearchStore">
      <SearchBar
        className="SearchStore__search-bar field"
        placeholder="Busca una dirección"
        onSubmit={submitHandler}
        onInputClick={onInputClick}
        dropdownConfigs={{ ...dropdownConfigs, showDropdown }}
        onClear={clearHandler}
        onChange={queryChangeHandler}
        onInputBlur={() => setShowDropdown(false)}
      >
        {nearbyStores ? (
          <SearchStoreContentStyled className="SearchStoreContent">
            {nearbyStores.map((item, index) => {
              const { address, storeName } = item;
              return (
                <InfoCard
                  className="SearchStoreContent__store-info"
                  key={index}
                  title={address}
                  value={storeName}
                  onContentClick={() => changeHandler(item)}
                />
              );
            })}
          </SearchStoreContentStyled>
        ) : null}
      </SearchBar>
    </Styles>
  );
};

SearchStore.defaultProps = {};

export default SearchStore;
